import React, { useEffect, useState } from "react";
import { CloseButton, Modal } from "react-bootstrap";
import { useManageSegmentStore } from "./store";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input, Select, Checkbox, Row, Col, Radio } from "antd";
import {
  dropDownConditions,
  conditionTypeItems,
} from "modules/utilities/utility";
import TextFields from "./TextField";
import DynamicTextField from "./DynamicTextField";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { even } from "is_js";

function ManageSegmentModal({
  modalShow,
  setModalShow,
  contentKey,
  searchText,
}) {
  const {
    segmentDetailData,
    editSegmentData,
    segmentDetailLoading,
    editSegmentLoading,
    fetchSegmentDetail,
    updateEditSegment,
    fetchSegmentData,
  } = useManageSegmentStore();
  const [form] = Form.useForm();
  const { setToaster } = useToast();
  const [loading, setLoading] = useState(false);
  const [isActive, setIsActive] = useState(true);
  const [condition, setCondition] = useState(null);
  const [conditionType, setConditionType] = useState(null);
  const [value, setValue] = useState(null);
  const [fromValue, setFromValue] = useState(null);
  const [toValue, setTovalue] = useState(null);
  const [conditionItems, setCondtionItems] = useState([]);
  const [isAnd, setIsAnd] = useState(true);
  const [isTwoInputs, setIsTwoInputs] = useState(false);
  const [type, setType] = useState("text");
  const [showMessage, setShowMessage] = useState("");

  const formStatus = [
    "gender",
    "form status",
    "form type",
    "order type",
    "order status",
    "engagement tag",
    "hair loss stages",
  ];

  const formOrder = ["age", "order count", "order value"];

  const isTypeText = (value) => {
    if (formStatus.includes(value)) {
      return true;
    } else {
      return false;
    }
  };

  useEffect(() => {
    fetchSegmentDetail(contentKey);
  }, [contentKey]);

  useEffect(() => {
    if (showMessage) {
      setTimeout(() => setShowMessage(""), 2000);
    }
  }, [showMessage]);

  useEffect(() => {
    if (!modalShow) {
      setLoading(false);
      clearAll();
      form.resetFields();
    }
  }, [modalShow]);

  useEffect(() => {
    if (segmentDetailData?.data) {
      const data = segmentDetailData?.data;
      let condArr = JSON.parse(data?.meta?.ref);
      const arrayData = condArr.pop();
      setCondition(arrayData["condition"]);
      setConditionType(arrayData["conditionType"]);
      setIsAnd(arrayData["isAnd"]);
      const value = arrayData?.condition;
      if (isTypeText(value)) {
        setConditionType("=");
        setIsTwoInputs(false);
        setType("text");
      } else if (
        value === "age" ||
        value === "order count" ||
        value === "order value"
      ) {
        setType("number");
      } else {
        setType("date");
      }
      if (arrayData?.value !== undefined) {
        setValue(arrayData?.value);
      } else {
        setIsTwoInputs(true);
        setFromValue(arrayData?.fromValue);
        setTovalue(arrayData?.toValue);
        setIsTwoInputs(arrayData?.isTwoInputs);
      }
      setCondtionItems(condArr);
      form.setFieldsValue({
        segmentName: data?.display_name,
      });
      setIsActive(data?.is_active);
    }
  }, [segmentDetailData, modalShow]);

  const handleConditionType = (value) => {
    setConditionType(value);
    if (value === "between") {
      setIsTwoInputs(true);
    } else {
      setIsTwoInputs(false);
    }
  };
  const handleConditionChange = (value) => {
    setCondition(value);
    setValue(null);
    setFromValue(null);
    setTovalue(null);
    if (isTypeText(value)) {
      setIsTwoInputs(false);
      setType("text");
    } else if (formOrder.includes(value)) {
      setType("number");
    } else {
      setType("date");
    }
    setConditionType("=");
  };
  const tailLayout = {
    wrapperCol: { offset: 10 },
  };

  const handleDelete = (delIndex) => {
    let condArr = conditionItems;
    condArr = condArr.filter((cond, mapIndex) => {
      return mapIndex !== delIndex;
    });
    setCondtionItems(condArr);
  };

  const isOnlyCharacters = (str) => {
    return /^[A-Za-z ]+$/i.test(str);
  };

  const handleDynamicOnChange = (event, index) => {
    const { name, value } = event.target;
    let data = [...conditionItems];
    if (name === "fromValue" || name === "toValue" || name === "value") {
      if (
        isTypeText(
          data[index]["condition"] && data[index]["condition"] === "form type"
        )
      ) {
        if (!isOnlyCharacters(value)) {
          data[index][name] = "";
          setCondtionItems(data);
          return setShowMessage("Please Enter only letters");
        }
      }
    }
    if (name === "conditionType") {
      if (value === "between") {
        data[index]["isTwoInputs"] = true;
        data[index]["value"] = undefined;
      } else {
        data[index]["isTwoInputs"] = false;
      }
    }
    if (name === "condition") {
      data[index]["value"] = null;
      data[index]["toValue"] = null;
      data[index]["fromValue"] = null;
      data[index]["conditionType"] = null;
      data[index]["isTwoInputs"] = false;
      if (isTypeText(value)) {
        data[index]["conditionType"] = "=";
        data[index]["type"] = "text";
      } else if (formOrder.includes(value)) {
        data[index]["type"] = "number";
      } else {
        data[index]["type"] = "date";
      }
    }
    if (name === "isAnd") {
      data[index][name] = !data[index][name];
    } else {
      data[index][name] = value;
    }
    setCondtionItems(data);
  };

  const onAddCondition = () => {
    if (condition === null) return setShowMessage("Please select condtion");

    if (conditionType === null)
      return setShowMessage("Please select condtion type");

    let conditionObject;

    if (
      condition === "age" ||
      condition === "order count" ||
      condition === "order value"
    ) {
      if (isTwoInputs) {
        if (parseInt(fromValue) <= 0) {
          return setShowMessage("Number should be greater than zero");
        }
        if (parseInt(toValue) <= parseInt(fromValue)) {
          return setShowMessage("To Value should be greater than from value");
        }
      } else {
        if (parseInt(value) <= 0) {
          return setShowMessage("Number should be greater than zero");
        }
      }
    }

    if (isTwoInputs) {
      if (fromValue === null && fromValue.trim() === "")
        return setShowMessage("Please Enter From value");
      if (toValue === null && toValue.trim() === "")
        return setShowMessage("Please enter to value");
      if (isTypeText(condition) && condition === "form type") {
        if (!isOnlyCharacters(fromValue) || !isOnlyCharacters(toValue)) {
          return setShowMessage("Please Enter only letters");
        }
      }
      conditionObject = {
        condition,
        conditionType,
        fromValue,
        toValue,
        isAnd,
        type,
        isTwoInputs,
      };
    } else {
      if (value === null && value === "") {
        return setShowMessage("Please Enter the value of the condition");
      }
      if (isTypeText(condition) && condition === "form type") {
        if (!isOnlyCharacters(value)) {
          return setShowMessage("Please Enter only letters");
        }
      }
      conditionObject = {
        condition,
        conditionType,
        value,
        isAnd,
        type,
        isTwoInputs,
      };
    }
    let condArr = conditionItems;
    condArr.push(conditionObject);
    setCondtionItems(condArr);
    setConditionType(null);
    setCondition(null);
    setValue(null);
    setFromValue(null);
    setTovalue(null);
    setType("text");
    setIsTwoInputs(false);
  };
  const handleSubmit = async (data) => {
    const { segmentName } = data;
    setLoading(true);
    conditionItems?.forEach((condItem) => {
      const { condition, isTwoInputs, fromValue, toValue, value, contentType } =
        condItem;

      if (["age", "order count", "order value"].includes(condition)) {
        if (isTwoInputs) {
          if (fromValue === null || toValue === null) {
            handleValidation("Please enter the value");
          } else if (parseInt(fromValue) <= 0) {
            handleValidation("Number should be greater than zero");
          } else if (parseInt(toValue) <= parseInt(fromValue)) {
            handleValidation("To Value should be greater than from value");
          }
        } else {
          if (value === null) {
            handleValidation("Please enter the value");
          } else if (parseInt(value) <= 0) {
            handleValidation("Number should be greater than zero");
          }
        }
      } else {
        if (isTwoInputs) {
          if (fromValue === null) {
            handleValidation("Please enter condition from value");
          }
          if (toValue === null) {
            handleValidation("Please enter condition to value");
          }
        } else {
          if (value === null) {
            handleValidation("Please enter condition value");
          }
        }
      }

      if (contentType === null) {
        handleValidation("Please Select condition type");
      }
    });

    function handleValidation(message) {
      setLoading(false);
      setShowMessage(message);
    }

    try {
      if (condition === null) {
        setLoading(false);
        return setShowMessage("Please select condtion");
      }
      if (conditionType === null && conditionType === "") {
        setLoading(false);
        return setShowMessage("Please select condtion type");
      }
      if (formOrder.includes(condition)) {
        if (isTwoInputs) {
          if (parseInt(fromValue) <= 0) {
            setLoading(false);
            return setShowMessage("Number should be greater than zero");
          }
          if (parseInt(toValue) <= parseInt(fromValue)) {
            setLoading(false);
            return setShowMessage("To Value should be greater than from value");
          }
        } else {
          if (parseInt(value) <= 0) {
            setLoading(false);
            return setShowMessage("Number should be greater than zero");
          }
        }
      }

      let conditionObject;
      if (isTwoInputs) {
        if (fromValue === null && fromValue.trim() === "") {
          setLoading(false);
          return setShowMessage("Please Enter From value");
        }
        if (toValue === null && toValue.trim() === "") {
          setLoading(false);
          return setShowMessage("Please enter to value");
        }
        if (isTypeText(condition) && condition === "form type") {
          if (!isOnlyCharacters(fromValue) || !isOnlyCharacters(toValue)) {
            setLoading(false);
            return setShowMessage("Please Enter only letters");
          }
        }
        conditionObject = {
          condition,
          conditionType,
          fromValue,
          toValue,
          isAnd,
          type,
          isTwoInputs,
        };
      } else {
        if (!value || value === "") {
          setLoading(false);
          return setShowMessage("Please Enter the value of the condition");
        }
        if (isTypeText(condition) && condition === "form type") {
          if (!isOnlyCharacters(value)) {
            setLoading(false);
            return setShowMessage("Please Enter only letters");
          }
        }
        conditionObject = {
          condition,
          conditionType,
          value,
          isAnd,
          type,
          isTwoInputs,
        };
      }
      const jsonData = JSON.stringify([...conditionItems, conditionObject]);
      const object = { displayName: segmentName, ref: jsonData, isActive };
      updateEditSegment(
        contentKey,
        object,
        setToaster,
        fetchSegmentData,
        searchText,
        setModalShow
      );
    } catch (err) {
      setToaster("Error", "Error is happened", "danger");
    }
  };

  const clearAll = () => {
    form.resetFields();
    setConditionType(null);
    setCondition(null);
    setValue(null);
    setCondtionItems([]);
    setFromValue(null);
    setTovalue(null);
    setType("text");
    setIsTwoInputs(false);
  };
  return (
    <div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter" className="w-100">
            {showMessage ? (
              <div className="text-warning" style={{ marginLeft: "40%" }}>
                {" "}
                {showMessage}{" "}
              </div>
            ) : (
              <div className="text-white">Header</div>
            )}
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body
          className="scrollable-container"
          style={{ maxHeight: "82vh", overflowY: "scroll" }}
        >
          <Form form={form} onFinish={handleSubmit}>
            <Form.Item
              label="Segment Name"
              name="segmentName"
              rules={[
                { required: true, message: "Please enter segment name" },
                {
                  pattern: new RegExp(/^[a-zA-Z0-9\conditionData]+$/),
                  message: "Please enter only alpha numerics only",
                },
              ]}
            >
              <Input placeholder="" />
            </Form.Item>

            <Form.Item label="Status">
              <Checkbox
                style={{ marginLeft: "12%" }}
                checked={isActive}
                onChange={({ target }) => setIsActive(target.checked)}
              >
                {isActive ? "Active" : "Inactive"}
              </Checkbox>
            </Form.Item>
            <h3>Conditions</h3>
            {conditionItems.map((contentData, index) => (
              <Row key={index}>
                <Row className="">
                  {index !== 0 && (
                    <Col style={{ marginLeft: "10px", marginBottom: "10px" }}>
                      <Radio
                        checked={contentData.isAnd}
                        name="isAnd"
                        onChange={(event) => {
                          handleDynamicOnChange(event, index);
                        }}
                      >
                        AND
                      </Radio>
                      <Radio
                        checked={!contentData.isAnd}
                        name="isAnd"
                        onChange={(event) => {
                          handleDynamicOnChange(event, index);
                        }}
                      >
                        OR
                      </Radio>
                    </Col>
                  )}
                </Row>
                <Row
                  key={index}
                  style={{ marginBottom: "15px", width: "100%" }}
                >
                  <Col style={{ marginRight: "20px", width: "170px" }}>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Condition Name"
                      value={contentData.condition}
                      onChange={(_event) => {
                        const event = {
                          target: {
                            value: _event,
                            name: "condition",
                          },
                        };
                        handleDynamicOnChange(event, index);
                      }}
                      options={dropDownConditions}
                    />
                  </Col>
                  <Col style={{ marginRight: "20px", width: "170px" }}>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Condition Type"
                      value={contentData.conditionType}
                      disabled={isTypeText(contentData.condition)}
                      onChange={(_event) => {
                        const event = {
                          target: {
                            value: _event,
                            name: "conditionType",
                          },
                        };
                        handleDynamicOnChange(event, index);
                      }}
                      options={conditionTypeItems}
                    />
                  </Col>
                  <Col style={{ marginRight: "20px", width: "200px" }}>
                    {!contentData.isTwoInputs ? (
                      <div style={{ display: "flex" }}>
                        <DynamicTextField
                          placeHolder="Condition Value"
                          value={contentData.value}
                          type={contentData.type}
                          name="value"
                          condition={contentData.condition}
                          onChange={(event) => {
                            handleDynamicOnChange(event, index);
                          }}
                        />
                        <MinusCircleOutlined
                          onClick={() => handleDelete(index)}
                          style={{ marginLeft: "20px", marginTop: "10px" }}
                        />
                      </div>
                    ) : (
                      <>
                        <div style={{ display: "flex" }}>
                          <div style={{ marginRight: "15px" }}>
                            <DynamicTextField
                              placeHolder="Condition from Value"
                              value={contentData.fromValue}
                              type={contentData.type}
                              name="fromValue"
                              condition={contentData.condition}
                              onChange={(event) => {
                                handleDynamicOnChange(event, index);
                              }}
                            />
                          </div>
                          <div>
                            <DynamicTextField
                              placeHolder="Condition to Value"
                              value={contentData.toValue}
                              type={contentData.type}
                              name="toValue"
                              setValue={setTovalue}
                              minDate={contentData.fromValue}
                              condition={contentData.condition}
                              onChange={(event) => {
                                handleDynamicOnChange(event, index);
                              }}
                            />
                          </div>
                          <MinusCircleOutlined
                            onClick={() => handleDelete(index)}
                            style={{ marginLeft: "20px", marginTop: "10px" }}
                          />
                        </div>
                      </>
                    )}
                  </Col>
                </Row>
              </Row>
            ))}
            <Row>
              {conditionItems.length !== 0 && (
                <Col style={{ marginLeft: "10px", marginBottom: "10px" }}>
                  <Radio
                    checked={isAnd}
                    onChange={(event) => {
                      setIsAnd(event.target.checked);
                    }}
                  >
                    AND
                  </Radio>
                  <Radio
                    checked={!isAnd}
                    onChange={(event) => {
                      setIsAnd(!event.target.checked);
                    }}
                  >
                    OR
                  </Radio>
                </Col>
              )}
            </Row>
            <Row>
              <Col
                style={{
                  marginRight: "20px",
                  width: "170px",
                  height: "100px",
                  alignItems: "center",
                }}
              >
                <Select
                  style={{ width: "100%" }}
                  placeholder="Condition Name"
                  value={condition}
                  onChange={(role) => {
                    handleConditionChange(role);
                  }}
                  options={dropDownConditions}
                />
              </Col>
              <Col style={{ marginRight: "20px", width: "170px" }}>
                <Select
                  style={{ width: "100%" }}
                  placeholder="Condition Type"
                  disabled={isTypeText(condition)}
                  value={conditionType}
                  onChange={(role) => {
                    handleConditionType(role);
                  }}
                  options={conditionTypeItems}
                />
              </Col>
              <Col style={{ marginRight: "20px", width: "170px" }}>
                {!isTwoInputs ? (
                  <TextFields
                    placeHolder="Condition Value"
                    value={value}
                    type={type}
                    setValue={setValue}
                    condition={condition}
                  />
                ) : (
                  <>
                    <div style={{ display: "flex" }}>
                      <div style={{ marginRight: "15px" }}>
                        <TextFields
                          placeHolder="Condition from Value"
                          value={fromValue}
                          type={type}
                          setValue={setFromValue}
                          condition={condition}
                        />
                      </div>
                      <div>
                        <TextFields
                          placeHolder="Condition to Value"
                          value={toValue}
                          type={type}
                          setValue={setTovalue}
                          minDate={fromValue}
                          condition={condition}
                        />
                      </div>
                    </div>
                  </>
                )}
              </Col>
            </Row>
            <Row style={{ width: "200px" }}>
              <Button
                type="dashed"
                onClick={() => {
                  onAddCondition();
                }}
                block
                icon={<PlusOutlined />}
              >
                Add Condition
              </Button>
            </Row>
            <br />
            <Form.Item {...tailLayout}>
              <Button htmlType="submit" loading={loading} type="primary">
                Save Segment
              </Button>
            </Form.Item>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ManageSegmentModal;
